import { render, staticRenderFns } from "./GanttBoard.vue?vue&type=template&id=431092ca&"
import script from "./GanttBoard.vue?vue&type=script&lang=js&"
export * from "./GanttBoard.vue?vue&type=script&lang=js&"
import style0 from "./GanttBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports